import gql from 'graphql-tag';

export const FETCH_FIKALY_ORGANIZATION = gql`
  query fetchFiskalyOrganization {
    fetchFiskalyOrganization {
      available
    }
  }
`;
